<template>
	<div style="background:var(--grey-2);border-radius: 5px;">
		<div class="flexcenter" style="padding:10px;align-items: stretch;">
			<div class="flexcenter" style="background:var(--bg-discount);color:white;padding:10px;font-size:150%;border-radius: 5px;">
				{{ this.discountModel?.label }}
			</div>
			<div class="flexcenter" style="flex-direction: column;align-items: start;margin-left:10px;">
				<b style="color:grey;">Rabatterat ÅF-Pris</b>
				<div class="flexcenter" style="margin-top:5px;">


					<div v-for="discount in this.discountModel?.discountList" :key="discount.discountId"
						style="background:var(--grey-4);padding:3px;border-radius: 3px;font-size:80%;margin-right:5px;"> {{
						discount?.description }}</div>

				</div>

			</div>

		</div>

	</div>
</template>
<script>

//import { PRODUCT_STORE_ACTION } from '@/store/product-store';
//import EntityHeaderSort from "@/components/entity/EntityHeaderSort.vue";
//import listHelper from "@/helper/list-helper.js";
//import { logMixin } from "@/mixins/logMixin.js";

export default {
	name: "DiscountModelView",
	components: {},
	mixins: [],
	props: {
		discountModel: Object
	},
	data() {
		return {

		};
	},

};
</script>

<style scoped></style>